// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Cpszq","main-image":"Header_main-image__e+OOY"};